import * as actionTypes from './actionTypes';

export const toggleModal = (message) => {
  return {
    type: actionTypes.TOGGLE_MODAL,
    message: message
  }
}

export const toggleDrawer = (toggleAction) => {
  return {
    type: actionTypes.TOGGLE_DRAWER,
    toggleAction: toggleAction
  }
}

export const displayPageError = () => {
  return {
    type: actionTypes.DISPLAY_PAGE_ERROR
  }
}

export const clearPageError = () => {
  return {
    type: actionTypes.CLEAR_PAGE_ERROR
  }
}

export const logCurrentPath = (path) => {
  return {
    type: actionTypes.LOG_CURRENT_PATH,
    path: path
  }
}

const toggleMenuMouseTracker = (toggleAction) => {
  return {
    type: actionTypes.TOGGLE_MENU_MOUSE_TRACKER,
    toggleAction: toggleAction
  }
}

export const toggleUserMenu = (toggleAction) => {
  return (dispatch) => {
    dispatch(toggleMenuMouseTracker(toggleAction));
    dispatch({ type: actionTypes.TOGLE_USER_MENU, toggleAction: toggleAction });
  }
}


// WEBPACK FOOTER //
// ./src/store/actions/globalActions.jsx